import React, { Component } from 'react'
import CSSModules from 'helpers/CSSModulesUtil'
import { connect } from 'react-redux'
import { compose } from 'redux'
import { Flex, Box } from 'reflexbox'
import {
  CellMeasurerCache,
} from 'react-virtualized'
import Input from './Input'
import scrollbarSize from 'dom-helpers/util/scrollbarSize'

import { CardText } from 'react-toolbox/lib/card'
import CardTitle from './CardTitle'
import Card from './Card'
import MultiGrid from 'components/fulcrum/multiGrid/index'
import Layout from './Layout'

import BodyCell from './BodyCell'
import LeftBodyCell from './LeftBodyCell'
import LeftHeaderCell from './LeftHeaderCell'
import HeaderCell from './HeaderCell'

import {
  initializeProjectList,
  updateInputValue,
  onEnterPress,
} from './actions'
import {
  cellMeasureCacheDefaults,
  gridParams,
  leftGridParams,
  headerGridParams,
  listOrder,
  FETCH_PROJECT_LIST
} from './constants'
import {
  listSelector,
  inputValueSelector,
} from './selectors'

import ProgressBarHoc from 'containers/Async/AsyncProgressBar'

import styles from './styles.scss'

const ProgressBar = ProgressBarHoc([FETCH_PROJECT_LIST])

const mapStateToProps = (state) => {
  return {
    list: listSelector(state),
    inputValue: inputValueSelector(state),
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    initialize: () => dispatch(initializeProjectList()),
    updateInputValue: (value) => dispatch(updateInputValue(value)),
    onEnterPress: (event) => dispatch(onEnterPress(event)),
  }
}

class ProjectSearchPage extends Component {
  constructor(props) {
    super(props)
    this.cache = new CellMeasurerCache({
      ...cellMeasureCacheDefaults,
    })
  }

  componentDidMount() {
    this.props.initialize()
  }

  leftHeaderCellRenderer = ({columnIndex, key, parent, rowIndex, style}) => {
    return (
      <LeftHeaderCell
        getCache={this.getCache}
        columnIndex={columnIndex}
        key={key}
        parent={parent}
        rowIndex={rowIndex}
        style={style}
        content={this.getContent({rowIndex, columnIndex})}
      />
    )
  }

  leftCellRenderer = ({columnIndex, key, parent, rowIndex, style}) => {
    let width = style.width
    let top = style.top
    if (!isNaN(style.width))
      width = style.width - scrollbarSize()
    if (!isNaN(style.top))
      top = style.top - gridParams.rowHeight

    return (
      <LeftBodyCell
        getCache={this.getCache}
        columnIndex={columnIndex}
        key={key}
        parent={parent}
        rowIndex={rowIndex}
        content={this.getContent({rowIndex, columnIndex})}
        style={{...style, width, top}}
      />
    )
  }

  headerCellRenderer = ({columnIndex, key, parent, rowIndex, style}) => {
    const skipCell = (columnIndex >= leftGridParams.columnCount)
    let content = ''

    if (skipCell)
      content = this.getContent({rowIndex, columnIndex})

    return (
      <HeaderCell
        getCache={this.getCache}
        columnIndex={columnIndex}
        key={key}
        parent={parent}
        rowIndex={rowIndex}
        style={style}
        content={content}
      />
    )
  }

  cellRenderer = ({columnIndex, key, parent, rowIndex, style}) => {
    const skipCell = (columnIndex >= leftGridParams.columnCount)
    // skip header content
    // get content from skipped row index
    // but you must measure cell using the header
    let content = ''

    if (skipCell)
      content = this.getContent({
        rowIndex,
        columnIndex
      })

    return (
      <BodyCell
        getCache={this.getCache}
        columnIndex={columnIndex}
        key={key}
        parent={parent}
        rowIndex={rowIndex}
        style={style}
        content={content}
        to={this.getProjectLink({rowIndex})}
      />
    )
  }

  getContent = ({rowIndex, columnIndex}) => {
    const { list } = this.props
    let content = undefined

    if (list[rowIndex])
      content = list[rowIndex][columnIndex]

    return content
  }

  getProjectLink = ({rowIndex}) => {
    const { list } = this.props
    const projectId = this.getContent({rowIndex, columnIndex: listOrder['id']})
    return `/project/${projectId}/view`
  }

  getCache = () => this.cache

  render() {
    const {
      list,
      inputValue,
      updateInputValue,
      onEnterPress,
    } = this.props

    const GridComponent = (list.length > 0)
      ? (
          <MultiGrid
            list={list}
            gridParams={gridParams}
            leftGridParams={leftGridParams}
            headerGridParams={headerGridParams}
            getCache={this.getCache}
            cellRenderer={this.cellRenderer}
            headerCellRenderer={this.headerCellRenderer}
            leftCellRenderer={this.leftCellRenderer}
            leftHeaderCellRenderer={this.leftHeaderCellRenderer}
          />
        )
      : null

    return (
      <Layout>
        <Card>
          <Flex pr={2} justify='space-between'>
            <CardTitle>
              Project List
            </CardTitle>
            <Input
              icon='search'
              hint= 'Search Project...'
              value={inputValue}
              onChange={updateInputValue}
              onKeyPress={onEnterPress}
            />
          </Flex>
          <Box auto>
            { GridComponent }
            <ProgressBar/>
          </Box>
        </Card>
      </Layout>
    )
  }
}

const withConnect = connect(mapStateToProps, mapDispatchToProps)

const enhance = compose(
  withConnect
)

export default enhance(ProjectSearchPage)
